import { AutomationActionType } from 'services/automation/types';

const actionOptionsMapper = (type: AutomationActionType) => {
  switch (type) {
    case AutomationActionType.UPDATE_ATS:
      return 'Update ATS';
    case AutomationActionType.CREATE_CANDIDATE_NOTE_FROM_CONVERSATION:
      return 'Add candidate summary in ATS';
    default:
      return '';
  }
};

export const getActionOptions = ({
  actionOptionsAvailable
}: {
  actionOptionsAvailable: AutomationActionType[];
}) => {
  return actionOptionsAvailable.map((type) => ({
    value: type,
    label: actionOptionsMapper(type)
  }));
};
